import React from 'react'
import { ajax, getState, parseJson, Status, Loading } from '../../twd'
const state = getState('global-search.saved-searches', { savedSearches:[] })

export default ({refresh}) => {

    const [status, setStatus] = React.useState(refresh ? Status.LOADING : Status.LOADED)
    const [savedSearches, setSavedSearches] = React.useState(refresh ? [] : state.value.savedSearches)

    const lastAbort = React.useRef()

    React.useEffect(() => {

        var dismounted = false

        ;(async () => {
        if (status!==Status.LOADING) return

        try {
            if (lastAbort.current) {
                lastAbort.current()
            }

            let {data, abort} = ajax({
                url: '/esb/portfolio/savedQuerySearchByCurrentUser',
                method: 'GET'
            })

            lastAbort.current = abort

            let rs = ((await data) || [])
                .map(a => {
                    a.modified = new Date(a.modified)
                    a.queryText = parseJson(a.formText)
                    a.searchParams = (a.queryText || {}).metadata || a.queryText || {}
                    return a
                })
                .filter(a => {
                    return a.searchParams.searchType === 'offers'
                })
                .sort((a,b) => b.modified.valueOf() -a.modified.valueOf())
                .slice(0, 5)

            if (dismounted) return

            state.value.savedSearches = rs
            setSavedSearches(rs)

            setStatus(Status.LOADED)
        } catch(e) {
            if (dismounted) return

            setStatus(Status.FAILED_TO_LOAD)
        }
        })()

        return () => {
            dismounted = true

            if (lastAbort.current) {
                lastAbort.current()
                lastAbort.current = null
            }
        }
    }, [status, setStatus])

    return { status, Loading, savedSearches }

}